module.exports = __webpack_public_path__ + "static/media/04.abcbe587.png";